import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PortalModule } from '@angular/cdk/portal'
import { HeaderComponent } from './header/header.component'
import { SharedPolymorpheusModule } from '@alliance/shared/polymorpheus'
import { SharedWebApisMutationObserverModule } from '@alliance/cdk/viewport'

@NgModule({
  imports: [CommonModule, PortalModule, SharedPolymorpheusModule, SharedWebApisMutationObserverModule],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class SharedHeaderFeatureHeadlessModule {}
